import { render, staticRenderFns } from "./BrokersFooterComparison.vue?vue&type=template&id=ee423ad4&"
import script from "./BrokersFooterComparison.vue?vue&type=script&lang=ts&"
export * from "./BrokersFooterComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports